<template>
  <div style="min-width: 575px;">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div v-if="Object.keys(buttonDiretorio).length >= 1" style="text-align: right; margin-top: 10px;">
        <RF-Button 
          :cpntId='buttonDiretorio.id'
          :cpntStatus='buttonDiretorio.status' 
          :cpntTipo='buttonDiretorio.tipo' 
          :cpntIcone='buttonDiretorio.icone' 
          :cpntTexto='buttonDiretorio.texto' 
          :cpntClass='buttonDiretorio.class' 

          @onClickButton='buttonDiretorio.onClick'
        ></RF-Button>
      </div>

      <div v-if="diretorios.length >= 1">
        <ul class="fa-ul" v-for="(cofre, index) in diretorios" :data-time="time" :key="index">
          <li>
            <div @click="configDiretorioCofreOpen(index)" style="cursor: pointer;">
              <span class="fa-li" ><i :class="cofre.open === true ? 'far fa-folder-open' : 'far fa-folder'"></i></span>
              {{ cofre.dir_nome }}
            </div>
            <ul v-show="cofre.open" class="fa-ul" v-for="(pasta, index1) in pastas.filter(item => item.uuid_pai === cofre.uuid)" :key="index1">
              <li>
                <span class="fa-li" ><i class="far fa-folder"></i></span>
                {{ pasta.dir_nome }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- <ul class=”setor”>
        <a href=”#” onclick=”open_setor()”><li >Setor</li></a>
      </ul>
      <ul class=”sub”>
        <a href=”#” onclick=”open_sub_setor()”><li >Sub</li></a>
      </ul>
      <ul class=”arquivo”>
        <li>Arquivo</li>
      </ul> -->
      <!--
      <div class="contratosConfigDir contratosConfigDir-cofre">
        <RF-Tabela :data-time='time'
          :cpntTime='time'
          :cpntId='tabela.cofre.id'
          :cpntStatus='tabela.cofre.status'
          :cpntButtonImprimir='tabela.cofre.acoes.btImprimir'
          :cpntButtonAtualizar='tabela.cofre.acoes.btAtualizar'
          :cpntFraseTop='tabela.cofre.fraseTop'
          :cpntColuna='tabela.cofre.coluna'
          :cpntLinha='tabela.cofre.linha'
          :cpntCountAll='tabela.cofre.countAll'
          :cpntColspan='tabela.cofre.colspan'
          :cpntButtonsAcoes='tabela.cofre.acoes.buttons'
          :cpntMper='tabela.cofre.mper'
          :cpntPagina='tabela.cofre.pagina'
          :cpntCheckboxEditar='tabela.cofre.checkboxEditar'
          :cpntMostrar='tabela.cofre.mostrar'

          :ref='tabela.cofre.id'
        ></RF-Tabela>
      </div>

      <div class="contratosConfigDir contratosConfigDir-pastas">
        <RF-Tabela :data-time='time'
          :cpntTime='time'
          :cpntId='tabela.pasta.id'
          :cpntStatus='tabela.pasta.status'
          :cpntButtonImprimir='tabela.pasta.acoes.btImprimir'
          :cpntButtonAtualizar='tabela.pasta.acoes.btAtualizar'
          :cpntFraseTop='tabela.pasta.fraseTop'
          :cpntColuna='tabela.pasta.coluna'
          :cpntLinha='tabela.pasta.linha'
          :cpntCountAll='tabela.pasta.countAll'
          :cpntColspan='tabela.pasta.colspan'
          :cpntButtonsAcoes='tabela.pasta.acoes.buttons'
          :cpntMper='tabela.pasta.mper'
          :cpntPagina='tabela.pasta.pagina'
          :cpntCheckboxEditar='tabela.pasta.checkboxEditar'
          :cpntMostrar='tabela.pasta.mostrar'

          :ref='tabela.pasta.id'
        ></RF-Tabela>
      </div>
      -->
    </template>
  </div>
</template>

<style scoped>
 /*  ul {
    margin:0;
  }
  ul.setor {
    list-style-image: url('./icon_mini_folder.png');
  }
  ul.setorOpen {
    list-style-image: url('./icon_mini_folder_a.png');
  }
  ul.sub {
    list-style-image: url('./icon_mini_folder.png');
    margin-left:20px;
    display:none;
  }
  ul.subOpen {
    list-style-image: url('./icon_mini_folder_a.png');
    margin-left:20px;
  }
  ul.arquivo {
    list-style-image: url('./icon_mini_file.png');
    margin-left:40px;
    display:none;
  } */



  .contratosConfigDir:first-child {
    margin-top: 10px;
  }
  .contratosConfigDir {
    margin: 20px 0px;
  }
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        tabela: {},
        buttonDiretorio: {},
        registros: [],
        diretorios: [],
        pastas: []
      }
    },
    mounted: function () {
      this.contratosConfigDirIniciar()
    },
    methods: {
      contratosConfigDirIniciar: function () {
        var self = this

        // SETA O STATUS GERAL
        self.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA O BOTÃO PARA ATUALIZAR VALORES
        self.buttonDiretorio = {
          status: '',
          id: 'contratos-config-dir-button',
          tipo: 'icone-texto',
          icone: { tipo: 'sync' },
          texto: '&nbsp;Sincronizar D4Sign',
          class: [ 'btn', 'btn-primary', 'btn-sm' ],
          onClick: self.contratosConfigDirAtualizar
        }

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        self.contratosConfigDirBuscarValores(function () {
          // CHAMA A FUNÇÃ PARA MONTAR A TABELA
          self.contratosConfigDirMontarTabela('cofre')

          // CHAMA A FUNÇÃ PARA MONTAR A TABELA
          self.contratosConfigDirMontarTabela('pasta')

          // SETA O STATUS GERAL
          self.statusGeral = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      contratosConfigDirBuscarValores: function (callback = null) {
        var self = this

        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { uuid: null, uuid_pai: null, dir_nome: null, last_at: null, last_user: { j: { usuario: null } }, status: null } }

        self.$store.state.comunicaAPI('/contrato/diretorio/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA OS DIRETORIOS RECEBIDOS
          self.registros = apiSuccess.data

          for (var key in self.registros) {
            self.registros[key].open = false
          }

          if (callback !== null) {
            callback()
          }
        }, function () {
          // SETA O STATUS GERAL
          self.statusGeral = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      contratosConfigDirMontarTabela: function (tipo) {
        switch (tipo) {
          case 'cofre':
            this.diretorios = this.registros.filter(item => item.status === '1' && item.uuid_pai === '')
            break

          case 'pasta':
            this.pastas = this.registros.filter(item => item.status === '1' && item.uuid_pai !== '')
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        // self.time = new Date().getTime()

        // // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        // self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela[tipo], function (tabelaSuccess) {
        // // SETA OS DADOS RECEBIDOS PARA TABELA
        //   self.tabela[tipo] = tabelaSuccess

        //   for (var key in self.tabela[tipo].linha) {
        //     switch (tipo) {
        //       case 'cofre':
        //         break

        //       case 'pasta':
        //         // BUSCA O COFRE DA PASTA
        //         var cofre = self.diretorios.filter(item => item.uuid === self.tabela[tipo].linha[key].uuid_pai)[0]

        //         // SETA O NOME DO COFRE
        //         self.tabela[tipo].linha[key].cofre = cofre.dir_nome

        //         // VERIFICA SE O COFRE ESTA EXCLUIDO
        //         if (cofre.status !== '1') {
        //           self.tabela[tipo].linha[key].cofre = ' <b>(Excluído)</b>'
        //         }
        //         break
        //     }

        //     if (self.tabela[tipo].linha[key].hasOwnProperty('last_user')) {
        //       self.tabela[tipo].linha[key]['rf-ult-alt'] = self.tabela[tipo].linha[key]['last_user_usuario'] + '<br/>' + self.tabela[tipo].linha[key]['last_at_ptbr']
        //     }
        //   }

        //   if (tipo === 'pasta') {
        //     self.tabela[tipo].linha.sort(function (a, b) {
        //       return a.cofre < b.cofre ? -1 : a.cofre > b.cofre ? 1 : 0
        //     })
        //   }

        //   // SETA O STATUS DA TABELA
        //   self.tabela[tipo].status = ''

        //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   self.time = new Date().getTime()
        // }, function (tabelaError) {
        //   // SETA O STATUS GERAL
        //   self.tabela[tipo].status = tabelaError

        //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   self.time = new Date().getTime()
        // })
      },
      contratosConfigDirAtualizar: function () {
        var self = this

        // SETA O STATUS DO BUTTON
        self.buttonDiretorio.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        var formData = {
          terceiro: 'd4sign'
        }

        self.$store.state.comunicaAPI('/contrato/diretorio', 'PUT', formData, function (apiSuccess) {
          // CHAMA A FUNÇÃO PARA MOSTAR A MENSAGEM RECEBIDA DA API
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            self.contratosConfigDirIniciar()
          })
        }, function (apiError) {
          // SETA O STATUS GERAL
          self.statusGeral = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, function (apiValid, apiStatus) {
          switch (apiStatus) {
            case 406:
              // APRESENTA A MENSAGEM RECEBIDA
              if (apiValid.hasOwnProperty('geralWeb') && typeof apiValid.geralWeb !== 'string') {
                self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb.join(' '), 'warning')
              } else if (apiValid.hasOwnProperty('geralWeb')) {
                self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb, 'warning')
              } else {
                self.$store.state.msgWarn('WEB [500]: Retorno API não identificado.', 'danger')
              }
              break

            case 409:
              // APRESENTA A MENSAGEM RECEBIDA
              if (apiValid.hasOwnProperty('geralWeb') && typeof apiValid.geralWeb !== 'string') {
                self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb.join(' '), 'danger')
              } else if (apiValid.hasOwnProperty('geralWeb')) {
                self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb, 'danger')
              } else {
                self.$store.state.msgWarn('WEB [500]: Retorno API não identificado.', 'danger')
              }
              break
          }

          // SETA O STATUS DO BUTTON
          self.buttonDiretorio.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      configDiretorioCofreOpen: function (index) {
        this.diretorios[index].open = !this.diretorios[index].open

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
